import { useSelector } from 'react-redux';

const EMPTY_MODELS = [];

export function useGptModels() {
  const models = useSelector((state) => state.gptModels?.models) || EMPTY_MODELS;
  const defaultId = useSelector((state) => state.gptModels?.defaultId) || null;
  const status = useSelector((state) => state.gptModels?.status) || 'idle';
  return { models, defaultId, status };
}

export function useDefaultGptModelId() {
  return useSelector((state) => state.gptModels?.defaultId) || '';
}
